import Cookies from 'js-cookie';
import { ENVIRONMENT } from './const';

const devGraphEndpoint = Cookies.get('bom-prod-graph')
  ? 'platform.bombas.com'
  : 'platform.bombas.fyi';

const config = {
  development: {
    platform_base_url: 'https://platform.bombas.fyi/api',
    contacts_service_url:
      'https://platform.bombas.fyi/api/v1/marketing/email-sign-up',
    constructorio: {
      // TODO: Revert back to staging key after testing
      // API_INDEX_KEY: 'key_alYw8oLPs5xbLBZo'
      API_INDEX_KEY: 'key_YY4lUhG9spPjjKw6'
    },
    bombasGraph: { url: `https://${devGraphEndpoint}/graphql` },
    storefrontGraph: {
      token: '6d6e7459e67d1b2f9049a59bfb359c35',
      url: 'https://shop.bombas.fyi/api/2024-07/graphql.json'
    },
    shopify_cdn_url: 'https://cdn.shopify.com/s/files/1/2527/5774/files',
    yotpo: 'L9sNxWEVaEVWIhyC1bojhFb5UnGGuY5FVSxNdHrH',
    shopify_base_url: 'https://shop.bombas.fyi',
    vercel_base_url: 'https://bombas.fyi',
    attentive: 'bombastest',
    http_404: '94420107335',
    loop_returns: {
      URL: 'https://staging1-bombas.loopreturns.com',
      API_KEY: '5d642b38fe27a0fc9c385adfd99e0a1756cf4a25'
    }
  },
  production: {
    platform_base_url: 'https://platform.bombas.com/api',
    contacts_service_url:
      'https://platform.bombas.com/api/v1/marketing/email-sign-up',
    constructorio: {
      API_INDEX_KEY: 'key_YY4lUhG9spPjjKw6'
    },
    bombasGraph: { url: 'https://platform.bombas.com/graphql' },
    storefrontGraph: {
      token: '2e65d999cd7e7e86193ad6accedac646',
      url: 'https://shop.bombas.com/api/2024-07/graphql.json'
    },
    shopify_cdn_url: 'https://cdn.shopify.com/s/files/1/1119/5850/files',
    yotpo: 'S583oi6v7ERuZuutMGFxLgv4PdLIXABCHUaE9f6y',
    shopify_base_url: 'https://shop.bombas.com',
    vercel_base_url: 'https://bombas.com',
    attentive: 'bombas',
    http_404: '91811741868',
    loop_returns: {
      URL: 'https://bombas.loopreturns.com',
      API_KEY: 'fdb714d87b6ebd81252043e5fdf5eb8aacdb916d'
    }
  },
  preproduction: {
    platform_base_url: 'https://preproduction.platform.bombas.com/api',
    contacts_service_url:
      'https://preproduction.platform.bombas.com/api/v1/marketing/email-sign-up',
    constructorio: {
      API_INDEX_KEY: 'key_XIIbIJmpP9VQ91HR'
    },
    bombasGraph: { url: 'https://preproduction.platform.bombas.com/graphql' },
    storefrontGraph: {
      token: '6d6e7459e67d1b2f9049a59bfb359c35',
      url: 'https://bombas-uk.myshopify.com/api/2024-07/graphql.json'
    },
    shopify_cdn_url: 'https://cdn.shopify.com/s/files/1/1119/5850/files',
    yotpo: 'L9sNxWEVaEVWIhyC1bojhFb5UnGGuY5FVSxNdHrH',
    shopify_base_url: 'https://bombas-uk.myshopify.com',
    vercel_base_url: 'https://bombas.tech',
    attentive: 'bombastest',
    http_404: '136075280738',
    loop_returns: {
      URL: 'https://staging1-bombas.loopreturns.com',
      API_KEY: '5d642b38fe27a0fc9c385adfd99e0a1756cf4a25'
    }
  }
};

export const {
  contacts_service_url,
  platform_base_url,
  constructorio,
  bombasGraph,
  storefrontGraph,
  shopify_cdn_url,
  yotpo,
  shopify_base_url,
  vercel_base_url,
  attentive,
  http_404,
  loop_returns
} = config[ENVIRONMENT];

export default {};
